module.exports = "/assets/dist/images/bodystyles_coupes.png?8ae1baebbb6e067233af52b61801cee4";